<template>
  <div>
    <div class="d-flex justify-content-end">
      <div class="mt-3 mr-3 mb-5">
        <q-input
          v-model="search.name"
          dense
          rounded
          outlined
          placeholder="検索"
        >
          <template v-slot:append>
            <q-icon name="search"></q-icon>
          </template>
        </q-input>
      </div>
    </div>
    <div class="table-list inner">
      <div class="content">
        <table class="table table-hover">
          <thead>
            <tr>
              <th width="25%" class="text-center no-border">{{ $t('帳票名称') }}</th>
              <th width="15%" class="text-center no-border"></th>
              <th width="15%" class="text-center no-border"></th>
              <th width="15%" class="text-center no-border"></th>
              <th width="15%" class="text-center no-border"></th>
              <th width="15%" class="text-center no-border">{{ $t('デフォルト設定') }}</th>
            </tr>
          </thead>
          <tbody class="tbody">
            <template v-if="!load && mixinGetItems.length">
              <template v-for="(item, index) in mixinGetItems">
                <tr :key="index" style="cursor: pointer;">
                  <td colspan="5" class="text-left" @click="onClickBusinessForm(item, index)">{{ item.name }}</td>
                  <td>
                    <q-toggle
                      dense
                      :value="item.isDefault"
                      @input="onChangeToggle(item)"
                      :disable="item.isDefault || isChangingToggle"
                    />
                  </td>
                </tr>
                <tr v-if="item.isShowDetail" :key="`add-${index}`" class="bg-white">
                  <td class="no-border"></td>
                  <td class="no-border">
                  </td>
                  <td class="no-border">
                    <q-btn rounded class="full-width" @click="previewModalOpen(item)">
                      <div class="row text-center no-wrap">
                        <svg class="icon mr-4" viewBox="0 0 24 24">
                          <use xlink:href="#file-22" />
                        </svg>
                        <div>{{ $t('プレビュー') }}</div>
                      </div>
                    </q-btn>
                  </td>
                  <td class="no-border">
                    <q-btn rounded class="full-width" @click="createPartnerBusinessFormModalOpen(item)">
                      <div class="row text-center no-wrap">
                        <svg class="icon mr-4" viewBox="0 0 24 24">
                          <use xlink:href="#user-24" />
                        </svg>
                        <div>{{ $t('顧客設定') }}</div>
                      </div>
                    </q-btn>
                  </td>
                  <td class="no-border">
                    <q-btn rounded class="full-width" @click="editModalOpen(item)">
                      <div class="row text-center no-wrap">
                        <svg class="icon mr-4" viewBox="0 0 24 24">
                          <use xlink:href="#pencil-9" />
                        </svg>
                        <div>{{ $t('アップロード') }}</div>
                      </div>
                    </q-btn>
                  </td>
                  <td class="no-border">
                    <q-btn rounded color="red" class="full-width" @click="deleteAlert(item)">
                      <div class="row text-center no-wrap">
                        <svg class="trash-can mr-4" viewBox="0 0 24 24">
                          <use xlink:href="#trash-can-1" />
                        </svg>
                        <div>{{ $t('削除') }}</div>
                      </div>
                    </q-btn>
                  </td>
                </tr>
              </template>
            </template>
            <template v-else-if="!load && !mixinGetItems.length">
              <tr>
                <td rowspan="2" colspan="99" class="text-center">
                  {{ $t('ノーデータメッセージ') }}
                </td>
              </tr>
            </template>
            <template v-else-if="load">
              <tr>
                <td colspan="12">
                  <div
                    class="d-flex justify-content-center m-5"
                    v-if="load"
                  >
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="inner d-flex justify-content-between">
      <paginate
        :page-count="mixinGetPageCount"
        :force-page="mixinGetForcePage"
        :page-range="3"
        :margin-pages="1"
        :click-handler="mixinClickCallback"
        :prev-text="'«'"
        :next-text="'»'"
        :container-class="'pagination justify-content-end mt-3 mr-0'"
        :page-class="'page-item'"
        :page-link-class="'page-link'"
        :prev-class="'page-item'"
        :prev-link-class="'page-link'"
        :next-class="'page-item'"
        :next-link-class="'page-link'"
        ref="page"
      >
      </paginate>
    </div>
    <svgs />
    <create-partner-business-form-modal
      ref="createPartnerBusinessFormModal"
      :partners="partners"
      @registed="emitInit"
    ></create-partner-business-form-modal>
    <preview-modal
      :company="company"
      ref="previewModal"
    ></preview-modal>
    <edit-modal
      ref="editModal"
    ></edit-modal>
  </div>
</template>

<script>
import svgs from './svgs'
import Api from '../../mixin/api'
import { mapGetters } from 'vuex'
import createPartnerBusinessFormModal from './createPartnerBusinessFormModal'
import previewModal from './previewModal'
import editModal from './editModal'

export default {
  props: {
    businessForms: Array,
    businessFormType: String,
    partners: Array,
    load: Boolean,
    company: Object,
  },
  mixins: [Api],
  data() {
    return {
      search: {
        name: '',
      },
      businessForm: {},
      businessFormId: null,
      isChangingToggle: false,
    }
  },
  components: {
    svgs,
    createPartnerBusinessFormModal,
    previewModal,
    editModal,
  },
  created() {
    //
  },
  methods: {
    async emitInit() {
      this.mixinCurrentPageClear()
      this.$emit('emit-registed')
    },
    async onChangeToggle(item) {
      this.isChangingToggle = true
      const businessForms = this.businessForms.filter(item => item.type === this.businessFormType)
      const businessForm = businessForms.find(item => item.isDefault) || null
      if (businessForm) businessForm.isDefault = false
      item.isDefault = true
      try {
        const params = {
          id: item.id,
          type: item.type,
          isDefault: item.isDefault,
        }
        await this.$axios.put(
          `${this.$appConfig.CommonApiUrl}/business_form/update_to_default`,
          params,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
      } catch (err) {
        if (businessForm) businessForm.isDefault = true
        item.isDefault = false
        this.$toasted.show('デフォルト切替に失敗しました')
      }
      this.isChangingToggle = false
    },
    onClickBusinessForm(item) {
      if (item.isShowDetail) return item.isShowDetail = false
      const showDetailItem = this.list.find(item => item.isShowDetail) || null
      if (showDetailItem) showDetailItem.isShowDetail = false
      this.$set(item, 'isShowDetail', true)
    },
    createPartnerBusinessFormModalOpen(item = {}) {
      this.businessForm = item
      this.$refs.createPartnerBusinessFormModal.createModalOpen(item)
    },
    previewModalOpen(item = {}) {
      this.$refs.previewModal.previewModalOpen(item)
    },
    editModalOpen(item = {}) {
      this.$refs.editModal.editModalOpen(item)
    },
    // 削除処理
    async deleteAlert(item) {
      const confirm = await this.$swal({
        text: this.$t(item.name) + this.$t('削除確認メッセージ'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: 'btn-danger',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        try {
          await this.$axios.delete(
            `${this.$appConfig.CommonApiUrl}/business_form`,
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
              params: { id: item.id },
            }
          )
          this.$swal.close()
          this.$toasted.success(this.$t('データ削除完了メッセージ'))
        } catch (err) {
          console.log(err)
          this.$swal.close()
          this.$toasted.show('削除に失敗しました')
        }
        await this.emitInit()
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
    getBusinessForms() {
      return this.businessForms
    },
    list() {
      const business_forms = this.getBusinessForms.filter(item => item.type === this.businessFormType)
      if (!this.search.name) return business_forms
      return business_forms.filter(item => item.name && item.name.indexOf(this.search.name) > -1)
    },
  },
}
</script>

<style lang="scss" scoped>
  .q-tabs-header {
    margin: 0 auto !important;
  }
  .trash-can {
    width: 21px;
    height: 21px;
    fill: white !important;
  }
  .icon {
    width: 21px;
    height: 21px;
  }
</style>
